<template>
  <div class="pdp-upper">
    <div class="container">
      <div v-if="device" class="flex wrap">
        <div class="col-45 white-bg">
          <device-preview :device="device.tmaPoVariantOptions"
                          :stickers="device.marketingTags"
                          @add-compare="addToCompare($props.device)"/>
        </div>
        <div class="col-55">
          <device-info :segment="segment" :device="device"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DevicePreview from '@/components/pdp/device-preview'
import DeviceInfo from '@/components/pdp/device-info'

import { lsSave } from '@/utils/localStorageController'

export default {
  props: {
    device: {
      type: Object
    },
    segment: String
  },
  components: {
    DevicePreview,
    DeviceInfo
  },
  methods: {
    addToCompare (device) {
      const data = {
        brands: device.brands,
        name: device.name,
        images: device.images,
        productOfferingPrices: device.productOfferingPrices,
        code: device.code,
        subcategories: [{ code: device.categories[0]?.code }]
      }
      lsSave('device-to-compare', data)
      window.location.replace(this.plpUrl(device))
    },
    plpUrl (category) {
      const urlPrefix = this.$props.segment === 'PRIVATNI' ? this.URL.private.PLP : this.URL.business.PLP
      switch (category.categories?.[0].code) {
        case 'televizori':
        case 'konzole':
          return urlPrefix.tv
        default:
          return `${urlPrefix.main}/${category.categories?.[0].code}`
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  padding: 0 !important;
}

.col-45 {
  @media (#{map-get($breakpoints, md)}) {
    width: 30% !important;
  }
  @media (#{map-get($breakpoints, lg)}) {
    width: 45% !important;
  }
}

.col-55 {
  width: 100%;
  @media (#{map-get($breakpoints, md)}) {
    width: 70% !important;
  }
  @media (#{map-get($breakpoints, lg)}) {
    width: 55% !important;
  }
}

.pdp-upper {
  overflow: hidden;
}

.white-bg {
  position: relative;
  padding-bottom: 25px;
  width: 100vw;
  margin: 0 calc(50% - 50vw);

  @media (#{map-get($breakpoints, md)}) {
    width: auto;
    padding-bottom: 0;
    margin: 0;

    &:after {
      display: none;
    }
  }

  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 50vw;
    background-color: $white;
    top: 0;
    right: 100%;
  }
}
</style>
